"use client";

import { useEffect, useRef } from "react";

/**
 * Loads FlippingBook after the embed anchor has been mounted.
 *
 * The vendor script scans the document for `.fbo-embed` anchors. Appending a
 * real script element here makes that work after a Next.js client navigation,
 * where scripts inside `dangerouslySetInnerHTML` are otherwise inert.
 */
export function FlippingBookEmbed({
  href,
  embedId,
  ratio,
  lightbox,
  width,
  height,
  version,
  scriptSrc,
  title,
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return undefined;

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.async = true;
    script.defer = true;
    script.dataset.flippingbookEmbed = embedId;
    document.body.appendChild(script);

    return () => script.remove();
  }, [embedId, scriptSrc]);

  return (
    <div
      ref={containerRef}
      className="w-full overflow-hidden rounded-base"
      data-flippingbook-embed
    >
      <a
        href={href}
        className="fbo-embed"
        data-fbo-id={embedId}
        data-fbo-ratio={ratio}
        data-fbo-lightbox={lightbox}
        data-fbo-width={width}
        data-fbo-height={height}
        data-fbo-version={version}
        style={{ maxWidth: "100%" }}
      >
        {title}
      </a>
    </div>
  );
}
